import type { UiMessages } from '../en/ui.ts'

// The Italian interface strings — the active language. Typed as `UiMessages` (derived from
// en/ui.ts): a key missing here does not compile.
export const IT_UI: UiMessages = {
  app: {
    name: 'Volée Backoffice',
    navigationLabel: 'Navigazione principale',
    openMenu: 'Apri il menu di navigazione',
    closeMenu: 'Chiudi il menu di navigazione',
    collapseMenu: 'Restringi il menu alle icone',
    expandMenu: 'Mostra le etichette del menu',
  },
  pagination: {
    position: 'Pagina {page} di {pageCount}',
    previous: 'Pagina precedente',
    next: 'Pagina successiva',
  },
  navigation: {
    home: 'Home',
    club: 'Società',
    pitch: 'Campi',
    kit: 'Kit',
    player: 'Giocatori',
    users: 'Utenti',
    register: 'Incarichi',
    leagues: 'Campionati',
    bulletinSources: 'Comunicati',
    matches: 'Partite',
    staff: 'Staff',
    settings: 'Impostazioni',
    signIn: 'Accedi',
    signOut: 'Esci',
    breadcrumb: 'Percorso di navigazione',
  },
  bulletinSource: {
    title: 'Comunicati',
    description: 'Le pagine da cui Volée prende i comunicati delle delegazioni.',
    list: 'Fonti dei comunicati',
    loading: 'Caricamento delle fonti',
    listError: 'Non è stato possibile caricare le fonti.',
    empty: 'Nessuna fonte',
    emptyDescription: 'Aggiungi la pagina dei comunicati di una delegazione.',
    noMatch: 'Nessuna fonte corrisponde.',
    statusLabel: 'Stato',
    all: 'Tutte',
    activeMany: 'Attive',
    inactiveMany: 'Spente',
    searchLabel: 'Cerca per nome o indirizzo',
    add: 'Aggiungi fonte',
    addTitle: 'Aggiungi una fonte',
    addDescription: 'Nasce spenta: la accendi dall’elenco.',
    editTitle: 'Modifica la fonte',
    edit: 'Modifica {name}',
    name: 'Nome',
    nameHelp: 'Come la riconosci: «Delegazione di Genova».',
    indexUrl: 'Indirizzo della pagina',
    indexUrlHelp: 'La pagina che elenca i comunicati, con https://',
    requiredField: 'Campo obbligatorio',
    create: 'Aggiungi',
    save: 'Salva',
    cancel: 'Annulla',
    close: 'Chiudi',
    created: 'Fonte aggiunta, spenta',
    updated: 'Fonte aggiornata',
    toggle: 'Attiva {name}',
    switchedOn: '{name} attivata',
    switchedOff: '{name} spenta',
    fixesTitle: 'Da sistemare',
    kindClub: 'Società non riconosciuta',
    kindPitch: 'Campo non riconosciuto',
    kindRead: 'Lettura fermata dal controllo',
    kindCategory: 'Categoria non gestita',
    kindOther: 'Non scritta',
    kindMatch: 'Partita corretta a mano',
    matchSays: 'il comunicato dice {when}',
    fixCreateClub: 'Crea la società',
    fixClubExists: 'È una società che c’è già',
    fixOurPitch: 'È un nostro campo',
    fixNotOurs: 'Non è nostro',
    fixReread: 'Rileggi',
    fixFollowBulletin: 'Segui il comunicato',
    fixIgnore: 'Ignora',
    fixWhichClub: 'Quale società?',
    fixWhichPitch: 'Quale campo?',
    fixSearching: 'Ricerca in corso',
    fixNoMatch: 'Nessun risultato',
    fixClubCreated: 'Società «{name}» creata',
    fixClubMatched: '«{name}» ora è {club}',
    fixPitchMatched: '«{name}» ora è il campo {pitch}',
    fixRereadDone: 'Il modello rileggerà quella parte',
    fixFollowed: 'La partita segue di nuovo il comunicato',
    fixIgnored: 'Non comparirà più',
    fixIgnoreOnce: 'Solo questa volta',
    fixIgnoreAlways: 'Sempre',
    fixIgnoredOnce: 'Non comparirà in questo controllo',
    ignoredTitle: 'Ignorate',
    ignoredOn: 'Ignorata il {when}',
    restore: 'Ripristina',
    restored: 'Ripristinata: torna fra le cose da sistemare',
    fixDone: 'Sistemata: vale dal prossimo controllo',
    fixesReady: '{count} sistemate: premi «Controlla ora» quando hai finito',
    checkNow: 'Controlla ora',
    checkNowLabel: 'Controlla ora {name}',
    checkStarted: 'Controllo avviato su {name}',
    checkRunning: 'Controllo in corso…',
    neverChecked: 'Mai controllata',
    checkDone: 'Controllata il {when} · {inserted} partite nuove, {updated} aggiornate',
    checkSkipped: '{count} saltate',
    checkRefused: '{count} gironi non passati',
    checkFailed: 'Controllo fallito il {when}: {error}',
    checkScheduled: 'programmata',
    scheduleDays: 'Giorni di lettura',
    scheduleDaysHelp:
      'In questi giorni Volée legge la fonte da sola. Nessuno: solo con «Controlla ora».',
    scheduleHour: 'Ora',
    scheduleHourHelp: 'La stessa per tutti i giorni scelti, ora italiana.',
    scheduleHourClear: 'Nessuna ora',
    scheduleDaysMissing: 'Scegli almeno un giorno',
    scheduleHourMissing: 'Scegli l’ora',
    scheduleSet: 'Programma le letture',
    scheduleEdit: '{schedule}: quando leggere {name}',
    scheduleAt: '{days} alle {hour}',
  },
  userMenu: {
    open: 'Account e sessione: {email}',
  },
  dashboard: {
    title: 'Backoffice Volée',
    signedInAs: 'Accesso effettuato come {email}',
    countsLoading: 'Caricamento dei conteggi',
    countUnavailable: 'Non disponibile',
    registerTitle: 'Anagrafica',
    clubsTotal: 'Società',
    pitchesTotal: 'Campi',
    playersTotal: 'Tesserati',
    requestsTitle: 'Iscrizioni da esaminare',
    requestsList: 'Iscrizioni in attesa di una decisione',
    requestsLoading: 'Caricamento delle iscrizioni in attesa',
    requestsError: 'Non è stato possibile caricare le iscrizioni in attesa.',
    requestsEmpty: 'Nessuna iscrizione in attesa',
    requestsEmptyDescription: 'Una richiesta compare qui appena una società la invia.',
    openQueue: 'Apri la coda',
    gatewaysTitle: 'Kit da guardare',
    gatewaysList: 'Kit che vogliono un controllo',
    gatewaysLoading: 'Caricamento dei kit',
    gatewaysError: 'Non è stato possibile caricare i kit.',
    gatewaysEmpty: 'Tutti i kit rispondono',
    gatewaysEmptyDescription:
      'Ogni kit in servizio ha parlato nell’ultima ora e non ha niente da controllare.',
    openFleet: 'Apri i kit',
  },

  signIn: {
    title: 'Accedi al backoffice',
    description: 'Area riservata allo staff Volée. Entra con le credenziali Volée.',
    email: 'Email',
    password: 'Password',
    submit: 'Accedi',
    forgotPassword: 'Ho dimenticato la password',
    reason: {
      'session-expired': 'La tua sessione è scaduta. Accedi di nuovo per continuare.',
      required: 'Quella pagina è riservata allo staff autenticato.',
    },
  },
  newPassword: {
    title: 'Scegli la tua password',
    description: 'La password temporanea va sostituita prima di continuare.',
    submit: 'Salva e continua',
    saved: 'Password impostata.',
  },
  mfa: {
    title: 'Inserisci il codice della tua app',
    description: 'Apri l’app di autenticazione e scrivi il codice che mostra per Volée.',
    code: 'Codice',
    submit: 'Accedi',
    cardTitle: 'Verifica in due passaggi',
    cardDescription: 'Un codice da un’app sul telefono, chiesto in aggiunta alla password.',
    statusOn: 'La verifica in due passaggi è attiva.',
    statusOff: 'La verifica in due passaggi non è attiva.',
    lostDeviceTitle: 'Se perdi il telefono',
    lostDevice:
      'Tieni l’app su un telefono che conservi. Se lo perdi non puoi più accedere da solo: scrivici e la disattiviamo noi.',
    enable: 'Attiva la verifica in due passaggi',
    disable: 'Disattiva',
    setupTitle: 'Inquadra il codice',
    setupDescription:
      'Inquadralo con la tua app di autenticazione, oppure digita la chiave a mano. Poi inserisci il codice che l’app mostra.',
    secret: 'Chiave',
    copySecret: 'Copia la chiave',
    secretCopied: 'Chiave copiata',
    unreadable:
      'Ora non riesco a sapere se la verifica in due passaggi è attiva. Riprova più tardi.',
    confirm: 'Conferma e attiva',
    cancel: 'Annulla',
    enabled: 'Verifica in due passaggi attivata.',
    disabled: 'Verifica in due passaggi disattivata.',
  },
  passwordReset: {
    title: 'Reimposta la password',
    description: 'Inserisci la tua email. Se esiste un account, arriva un codice per email.',
    email: 'Email',
    request: 'Invia il codice',
    codeTitle: 'Inserisci il codice',
    codeDescription: 'Controlla la posta, inserisci il codice e scegli una nuova password.',
    code: 'Codice',
    confirm: 'Salva la nuova password',
    done: 'Password aggiornata.',
    signInYourself: 'Accedi con la nuova password.',
    backToSignIn: 'Torna all’accesso',
  },
  password: {
    current: 'Password attuale',
    new: 'Nuova password',
    confirm: 'Conferma la nuova password',
    policyHint: 'Almeno {minLength} caratteri, con una maiuscola, una minuscola e una cifra.',
    mismatch: 'Le due password non coincidono.',
    required: 'Campo obbligatorio.',
    changeTitle: 'Cambia password',
    changeDescription: 'Qui resti collegato. Gli altri dispositivi mantengono la loro sessione.',
    changeSubmit: 'Cambia password',
    changed: 'Password cambiata.',
    signOutPartial: 'Sei uscito da qui, ma altri dispositivi potrebbero essere ancora collegati.',
  },
  settings: {
    title: 'Impostazioni',
    description: 'Il tuo account.',
    devBypassHint:
      'Questa sessione non ha un’identità Cognito: non c’è niente da cui uscire e nessuna password da cambiare.',
  },
  profile: {
    cardTitle: 'Profilo',
    description: 'Come ti vede il resto dello staff.',
    email: 'Email',
    emailHelp: 'L’indirizzo con cui accedi: non si cambia da qui.',
    lastName: 'Cognome',
    firstName: 'Nome',
    phone: 'Telefono',
    photo: 'Foto',
    photoDescription: 'L’immagine del tuo profilo staff.',
    photoAlt: 'La tua foto',
    uploadPhoto: 'Carica foto',
    replacePhoto: 'Sostituisci foto',
    removePhoto: 'Rimuovi foto',
    photoSaved: 'Foto salvata.',
    photoRemoved: 'Foto rimossa.',
    photoTooLarge: 'Il file supera {maxMb} MB.',
    save: 'Salva profilo',
    saved: 'Profilo salvato.',
    loading: 'Caricamento del profilo…',
    loadError: 'Non è stato possibile caricare il tuo profilo.',
  },
  session: {
    role: 'Ruolo: {role}',
    noRole: 'Nessun ruolo nel backoffice',
    expired: 'Sessione scaduta. Accedi di nuovo.',
    devBypass: 'Bypass di sviluppo',
    devBypassHint: 'Sessione locale senza Cognito: uscire non ha effetto.',
  },
  // Il collegamento società↔campo, che non appartiene a nessuno dei due capi.
  link: {
    primary: 'Campo principale',
    makePrimaryForClub: 'Rendi principale per questa società',
    makePrimaryPitch: 'Rendi principale',
    detach: 'Scollega',
    attached: 'Collegamento creato.',
    promoted: 'Campo principale aggiornato.',
    detached: 'Collegamento rimosso.',
  },
  club: {
    title: 'Società',
    description: 'Anagrafica delle società registrate. Area protetta: visibile solo allo staff.',

    list: 'Società registrate',
    searchLabel: 'Cerca per ragione sociale o nome breve',
    statusFilter: 'Filtra per stato',
    allStatuses: 'Tutti gli stati',
    sortLabel: 'Ordina per',
    sortLegalNameAsc: 'Ragione sociale (A–Z)',
    sortLegalNameDesc: 'Ragione sociale (Z–A)',
    sortCreatedDesc: 'Più recenti prima',
    sortCreatedAsc: 'Meno recenti prima',
    loading: 'Caricamento delle società…',
    listError: 'Non è stato possibile caricare l’elenco delle società.',
    empty: 'Nessuna società registrata.',
    emptyDescription: 'Inserisci la prima società per iniziare.',
    emptySearch: 'Nessuna società corrisponde alla ricerca.',
    emptySearchDescription: 'Controlla la scrittura, o svuota il campo per vedere tutte.',
    clearSearch: 'Svuota la ricerca',
    paginationLabel: 'Paginazione delle società',
    count: '{total} società registrate',

    newClub: 'Nuova società',
    newClubDescription:
      'Inserisci l’anagrafica. Campi, dispositivi e referente si collegano in un secondo momento.',
    details: 'Anagrafica',
    legalName: 'Ragione sociale',
    legalNameHelp: 'Il nome completo, come risulta all’atto costitutivo.',
    shortName: 'Nome breve',
    shortNameHelp: 'Come compare negli elenchi e nelle convocazioni.',
    logo: 'Logo',
    logoAlt: 'Logo di {name}',
    uploadLogo: 'Carica il logo',
    replaceLogo: 'Sostituisci il logo',
    changeLogo: 'Cambia il logo',
    removeLogo: 'Rimuovi il logo',
    logoSaved: 'Logo salvato.',
    logoRemoved: 'Logo rimosso.',
    logoTooLarge: 'Il file supera {maxMb} MB.',
    logoUploadFailedAfterCreate:
      'La società è stata creata, ma il logo non è stato caricato: riprova dalla scheda.',
    address: 'Indirizzo',
    region: 'Regione',
    province: 'Provincia',
    chooseRegion: 'Scegli una regione',
    chooseProvince: 'Scegli una provincia',
    chooseRegionFirst: 'Scegli prima la regione',
    noProvince: 'Non registrata',
    lndName: 'Nei comunicati della federazione',
    lndNameHelp:
      'Come la stampa la federazione, per esteso: A.N.P.I.SPORT E.CASASSA. L’importazione dei comunicati la riconosce già da sola quando la ragione sociale coincide; si compila qui quando i due nomi differiscono.',
    lndNameEmpty: 'Non collegata',
    status: 'Stato',
    statusMenu: 'Stato: {status}. Cambia stato',
    statusSaved: 'Stato cambiato in «{status}».',
    leaveActiveTitle: 'Portare {name} a «{status}»?',
    leaveActiveBody:
      'Solo le società attive ricevono le richieste di iscrizione delle famiglie: finché non torna attiva, {name} non ne riceverà di nuove.',
    leaveActiveConfirm: 'Cambia stato',
    requiredField: 'Campo obbligatorio.',
    create: 'Crea società',
    creating: 'Creazione…',
    edit: 'Modifica',
    save: 'Salva le modifiche',
    saving: 'Salvataggio…',
    cancel: 'Annulla',
    close: 'Chiudi',
    created: 'Società creata.',
    openCard: 'Apri la scheda',
    saved: 'Modifiche salvate.',
    clubNotFound: 'Questa società non esiste, o è stata rimossa.',
    backToList: 'Torna all’elenco',
    // La sezione organigramma della scheda
    officials: 'Organigramma',

    // La sezione squadre della scheda
    teams: 'Squadre',
    teamsDescription: 'Le squadre che la società schiera. Il campionato di ciascuna arriva dopo.',
    teamsLoading: 'Caricamento delle squadre…',
    teamsError: 'Non è stato possibile caricare le squadre di questa società.',
    noTeams: 'Questa società non ha ancora squadre.',
    noTeamsDescription: 'Aggiungi la prima qui sotto.',
    newTeam: 'Aggiungi una squadra',
    newTeamDescription:
      'Scegli la categoria. Se il club la schiera già, la nuova squadra prende una lettera libera, fino alla E.',
    ageGroup: 'Categoria',
    underAge: 'Limite di età',
    gender: 'Genere',
    seniores: 'Nessun limite (seniores)',
    bothYears: '1° e 2° anno',
    underAgeOption: 'Under {years}',
    category: 'Categoria',
    categoryOption: '{group} U{years} · {gender}',
    categoryOptionBothYears: '{group} 1° e 2° anno · {gender}',
    categoryOptionSeniores: '{group} · {gender}',
    teamLetter: 'Squadra {letter}',
    teamLetterField: 'Squadra',
    teamLetterNoteOne:
      'Di {category} il club ha già la squadra {taken}: si propone la {next}, come nei comunicati LND.',
    teamLetterNoteMany:
      'Di {category} il club ha già le squadre {taken}: si propone la {next}, come nei comunicati LND.',
    teamLetterFull: 'Categoria piena: di {category} il club ha già le squadre {taken}.',
    addTeam: 'Aggiungi',
    addingTeam: 'Aggiunta in corso…',
    teamCreated: 'Squadra aggiunta.',
    editTeam: 'Modifica',
    saveTeam: 'Salva',
    savingTeam: 'Salvataggio…',
    cancelTeam: 'Annulla',
    teamSaved: 'Squadra salvata.',
    deleteTeam: 'Elimina',
    teamDeleted: 'Squadra eliminata.',

    // Lo staff di una squadra, col posto di chi lo ha. Un incarico vive in una stagione, una squadra no.
    teamStaff: 'Staff della squadra',
    noTeamStaff: 'Nessuno nello staff',
    teamSeatMark: 'Posto di squadra',
    teamStaffLoading: 'Caricamento dello staff…',
    teamStaffError: 'Non è stato possibile caricare lo staff di questa società.',
    addTeamStaff: 'Assegna un allenatore',
    teamStaffPlaceholder: 'Scegli',
    noAssignableStaff: 'Nessun allenatore da aggiungere. Per nominarne uno vai in Organigramma.',
    removeTeamStaff: 'Togli',
    removeTeamStaffOf: 'Togli {name}',
    teamStaffAdded: 'Assegnato alla squadra con accesso di gestione.',
    teamStaffRemoved: 'Tolto dalla squadra. Resta nello staff della società.',

    // La sezione campi della scheda
    pitches: 'Campi',
    pitchesDescription: 'I campi su cui gioca questa società. Uno di essi è quello abituale.',
    pitchesLoading: 'Caricamento dei campi…',
    pitchesError: 'Non è stato possibile caricare i campi di questa società.',
    noPitches: 'Questa società non ha ancora un campo.',
    noPitchesDescription: 'Collega uno su cui già gioca, o creane uno nuovo qui sotto.',
    pitchCreated: 'Campo creato e collegato.',
    attachPitch: 'Collega un campo esistente',
    attachPitchDescription: 'Un campo comunale è condiviso: lo stesso può servire due società.',
    attachPitchLabel: 'Cerca il campo da collegare',
    attachPitchPlaceholder: 'Nome o indirizzo',
    attachPitchSearching: 'Ricerca…',
    attachPitchNoMatch: 'Nessun campo corrisponde alla ricerca.',
    newClubPitch: 'Crea un campo per questa società',
    newClubPitchDescription:
      'Creato e collegato in una sola richiesta, così non può avvenire a metà.',
    createAndAttachPitch: 'Crea e collega',
  },
  gateway: {
    inStock: 'In magazzino',
    kitName: 'Kit {number}',
    title: 'Kit',
    description:
      'Ciò che sta nell’armadietto di un campo: il gateway, il router con la SIM, le telecamere. Solo staff.',

    // I kit
    list: 'Kit',
    searchLabel: 'Cerca per numero del kit, identificativo hardware o SIM',
    kind: 'Configurazione',
    kinds: {
      raspberry_4g: 'Raspberry Pi e router 4G',
      nucbox_g10: 'GMKtec NucBox G10 e router 4G',
    },
    hostname: 'Hostname',
    noHostname: 'Nessun hostname',
    assign: 'Installa su un campo',
    move: 'Sposta',
    placeTitle: 'Assegna a un campo',
    moveTitle: 'Sposta su un altro campo',
    placeSave: 'Salva il campo',
    placeSaving: 'Salvataggio…',
    placed: 'Campo salvato.',
    renameFrom:
      'Nella console di Tailscale (Machines → Edit machine name) rinomina il nodo da {old} a {new}.',
    renameFirst:
      'Nella console di Tailscale (Machines → Edit machine name) dai al nodo il nome {new}.',
    renameHelp:
      'Il backoffice non parla con Tailscale: la casella è un promemoria, non una verifica.',
    renameConfirm: 'Ho rinominato il nodo su Tailscale',
    sshCommand: 'Accesso SSH',
    copySsh: 'Copia il comando',
    sshCopied: 'Comando copiato',
    consolePassword: 'Password di console',
    routerPassword: 'Password del router',
    cameraPassword: 'Password della camera',
    showPasswords: 'Mostra le password',
    copyConsolePassword: 'Copia la password di console',
    copyRouterPassword: 'Copia la password del router',
    copyCameraPassword: 'Copia la password della camera',
    passwordCopied: 'Password copiata',
    passwordsLoading: 'Caricamento delle password…',
    noConsolePassword: 'Nessuna password di console: questo kit non è stato preparato al banco.',
    noRouterPassword:
      'Nessuna password del router: il banco non ha preparato il router di questo kit.',
    noCameraPassword:
      'Nessuna password della camera: il banco non ha preparato la camera di questo kit.',
    router: 'Router 4G',
    routerModel: 'Modello del router',
    routerSerial: 'Seriale del router',
    routerFirmware: 'Firmware del router',
    noRouterValue: 'Non indicato',
    health: 'Salute',
    condition: 'Stato',
    identity: 'Identità',
    access: 'Accesso',
    moreActions: 'Altro',
    cameraDetails: 'Dettagli della telecamera',
    retiredDescription: 'Un kit ritirato resta legato al suo campo e non torna in magazzino.',
    upgradeAvailable: 'Da aggiornare',
    upgradeAvailableDescription:
      'Il gateway non gira l’ultima versione pubblicata: si aggiorna quando non registra.',
    upgradeRequested: 'Aggiornamento richiesto',
    conditionReasons: 'Perché va controllato',
    lastSeenColumn: 'Ultimo contatto',
    sortLabel: 'Ordina per',
    sortSerialAsc: 'Identificativo (A–Z)',
    sortSerialDesc: 'Identificativo (Z–A)',
    sortInstalledDesc: 'Installati di recente',
    sortInstalledAsc: 'Installati da più tempo',
    sortLastSeenDesc: 'Visti di recente',
    sortLastSeenAsc: 'Visti da più tempo',
    installedLine: 'Installato il {date}',
    installedSince: 'dal {date}',
    kitHeading: 'Kit',
    whereHeading: 'Dove',
    boxHeading: 'Scatola',
    seenHeading: 'Ultimo contatto',
    stateHeading: 'Stato',
    lastSeenLine: 'Ultimo contatto {date}',
    neverSeen: 'Mai visto',
    retired: 'Ritirato',
    loading: 'Caricamento dei kit…',
    listError: 'Non è stato possibile caricare l’elenco dei kit.',
    empty: 'Nessun kit, per ora.',
    emptyDescription:
      'Accendi un gateway al banco col router collegato: compare qui sopra entro un minuto. Nessuna scatola? Controlla che la SIM abbia il PIN disattivato e che il router abbia segnale.',
    emptySearch: 'Nessun kit corrisponde a questa ricerca.',
    emptySearchDescription: 'Controlla la scrittura, o svuota il campo per vederli tutti.',
    clearSearch: 'Azzera la ricerca',
    paginationLabel: 'Paginazione dei kit',
    count: '{total} kit',
    viewsLabel: 'Quali kit',
    viewAll: 'Tutti',
    fleetTitle: 'Tutti i kit',
    inStockTotal: 'In magazzino',
    installedTotal: 'Installati',
    attentionTotal: 'Da guardare',
    retiredTotal: 'Ritirati',

    // I kit di un campo, e installarne uno dal magazzino
    atPitch: 'Kit di questo campo',
    pageDescription:
      'Il kit nell’armadietto di questo campo, e dove se ne installa uno dal magazzino.',
    openList: 'Kit',
    installTitle: 'Installa un kit dal magazzino',
    installDescription: 'I kit si preparano al banco: qui scegli quale va in questo armadietto.',
    kitPicker: 'Kit',
    kitPlaceholder: 'Cerca per numero o identificativo hardware',
    kitSearching: 'Ricerca…',
    kitNoMatch: 'Nessun kit in magazzino corrisponde.',
    clearKit: 'Cambia kit',
    installSave: 'Installa',
    // Aggiungere una telecamera, e lo scanner
    addCamera: 'Aggiungi la telecamera',
    cameraAdded: 'Telecamera aggiunta.',
    cameraName: 'Nome',
    defaultCameraName: 'Camera',
    cameraMacHelp: 'Dalla lista dei dispositivi del router.',
    scan: {
      title: 'Inquadra il codice',
      hint: 'Tieni l’etichetta ferma e ben illuminata.',
      cancel: 'Annulla',
      starting: 'Apertura della fotocamera…',
      denied:
        'Il permesso della fotocamera è stato negato: concedilo nelle impostazioni del browser, o scrivi il codice a mano.',
      unavailable: 'Fotocamera non disponibile su questo dispositivo: scrivi il codice a mano.',
    },
    scanCameraSerial: 'Leggi il numero di serie',
    scanCameraUid: 'Leggi il QR dell’UID',
    pitchHelp: 'Il campo nel cui armadietto sta la scatola.',
    pitchPlaceholder: 'Cerca per nome o indirizzo',
    pitchSearching: 'Ricerca…',
    pitchNoMatch: 'Nessun campo corrisponde.',
    clearPitch: 'Cambia campo',
    noneAtPitch: 'Nessun kit installato su questo campo.',
    noneAtPitchDescription: 'Installane uno dal magazzino qui sotto: i kit si preparano al banco.',
    hardwareId: 'Identificativo hardware',
    installedOn: 'Installato il',
    installedOnHelp: 'Il giorno in cui la scatola è entrata nell’armadietto.',
    simIccid: 'ICCID della SIM',
    simIccidHelp:
      'Opzionale. 19 o 20 cifre, l’ultima è di controllo. È ciò che attribuisce il consumo dati.',
    requiredField: 'Campo obbligatorio.',
    noSim: 'Nessuna SIM',
    // La scheda
    record: 'Dati del kit',
    recordDescription: 'Il kit nell’armadietto: il gateway, il router e le telecamere.',
    recordLoading: 'Caricamento del kit…',
    gatewayNotFound: 'Questo kit non esiste.',
    backToFleet: 'Torna ai kit',
    pitch: 'Campo',
    appVersion: 'Versione dell’app',
    software: 'Software',
    targetVersion: 'Versione richiesta',
    noTargetVersion: 'Nessuna richiesta',
    latestVersion: 'Ultima pubblicata',
    noLatestVersion: 'Nessuna versione pubblicata',
    latestVersionError: 'Non è stato possibile leggere le versioni pubblicate.',
    upgradeTo: 'Aggiorna alla {version}',
    upgradeCancel: 'Annulla la richiesta',
    upgradeAsked: 'Aggiornamento richiesto.',
    upgradeCancelled: 'Richiesta annullata.',
    upgradeAll: 'Aggiorna tutti alla {version}',
    upgradeAllTitle: 'Aggiornare {count} kit alla {version}?',
    upgradeAllBody:
      'Ogni kit si aggiorna entro un quarto d’ora, quando non registra e non ha una partita in arrivo. La richiesta si annulla dalla scheda di ciascun kit.',
    upgradeAllUntried:
      'Si sblocca quando un kit acceso gira la {version}: aggiornane prima uno dalla sua scheda.',
    upgradeAllConfirm: 'Aggiorna tutti',
    upgradeAllCancel: 'Non ora',
    upgradeAllAsked: 'Aggiornamento richiesto a {count} kit.',
    upgradeAllNone: 'Ogni kit da aggiornare aveva già la richiesta.',
    maintenanceAsked: 'Richiesta inviata: l’esito compare qui entro dieci minuti.',
    maintenance: 'Manutenzione',
    maintenanceDescription:
      'Chiedi al kit di rifare un pezzo della sua configurazione. Il kit si collega ogni cinque minuti: riceve la richiesta al collegamento successivo e dice com’è andata a quello dopo, quindi l’esito compare qui entro dieci minuti.',
    maintenanceLoading: 'Caricamento richieste…',
    maintenanceEmpty: 'Nessuna richiesta finora.',
    maintenanceError: 'Non è stato possibile caricare le richieste.',
    maintenanceConfirm: 'Chiedi al kit',
    maintenanceCancel: 'Annulla',
    maintenanceRequestedBy: 'Chiesta da',
    maintenanceNobody: '—',
    maintenanceFinishedAt: 'Conclusa il',
    maintenanceWaiting: 'L’esito compare qui entro dieci minuti dalla richiesta.',
    interventions: 'Interventi',
    interventionsDescription:
      'Ogni pezzo sostituito e il ritiro del kit, con chi li ha registrati e che fine ha fatto il pezzo tolto.',
    interventionsLoading: 'Caricamento interventi…',
    interventionsEmpty: 'Nessun intervento finora.',
    interventionsError: 'Non è stato possibile caricare gli interventi.',
    interventionOpenedBy: 'Registrato da',
    interventionItemOut: '{outgoing} · {fate}',
    interventionItemSwap: '{outgoing} → {incoming} · {fate}',
    interventionCancel: 'Annulla l’intervento',
    interventionCancelled: 'Intervento annullato.',
    interventionNote: 'Nota',
    interventionNoteHelp: 'Facoltativa: cosa è successo, chi era al campo.',
    chooseOutcome: 'Scegli che fine fa',
    simSwap: 'Cambia la SIM',
    simSwapDescription:
      'Prima registri, poi cambi la SIM nel router. Il nuovo ICCID vale da subito, e l’intervento si chiude quando il kit si collega con la SIM nuova.',
    simSwapIccid: 'ICCID della SIM nuova',
    simSwapOutcome: 'Che fine fa la SIM tolta',
    interveneSave: 'Registra',
    interveneSaving: 'Registrazione…',
    intervened: 'Intervento registrato.',
    retire: 'Ritira il kit',
    retireDescription:
      'Il kit e le sue telecamere escono dal servizio oggi, e le registrazioni programmate si cancellano. Un ritiro non si annulla.',
    retireOutcomeOf: 'Che fine fa: {part}',
    retireCamera: 'telecamera «{name}»',
    retireChecklist: 'Prima di confermare:',
    retireTailscale: 'Ho cancellato il nodo del kit dalla console Tailscale.',
    retireSim: 'Ho chiesto all’operatore di disattivare la SIM, o il kit non ne ha.',
    retireConfirm: 'Ritira',
    retiring: 'Ritiro…',
    retiredToast: 'Kit ritirato.',
    interventionKinds: {
      replacement: 'Sostituzione',
      retirement: 'Ritiro',
    },
    boardSwap: 'Cambia il gateway',
    boardSwapDescription:
      'Prima registri, poi stacchi il gateway. La scheda nuova, con una SD appena scritta, si accende nell’armadietto e dal Banco diventa la scheda di questo kit. Prima di accenderla cancella il nodo vecchio dalla console Tailscale.',
    boardSwapSdOnly: 'Cambio solo la SD: la scheda resta.',
    boardSwapOutcome: 'Che fine fa il pezzo tolto',
    interventionSdOnly: 'SD del gateway',
    routerSwap: 'Cambia il router',
    routerSwapDescription:
      'Prima registri, poi stacchi il router: il kit deve comunicare per ricevere la richiesta. Collegato il router nuovo, il kit gli dà da solo la password, l’APN e la prenotazione della camera, anche senza internet.',
    cameraSwap: 'Cambia la telecamera',
    cameraSwapDescription:
      'Prima registri, poi stacchi la telecamera: il kit deve comunicare per ricevere la richiesta. Collegata la telecamera nuova, il kit la trova, le riserva 192.168.1.10 e la prepara con la password del kit.',
    cameraSwapWhich: 'Quale telecamera esce',
    cameraSwapChoose: 'Scegli la telecamera',
    maintenanceConfirmations: {
      router_wifi_off: {
        title: 'Spegnere il Wi-Fi del router?',
        body: 'Il kit spegne ogni rete Wi-Fi del router e controlla che risultino spente. Il kit non usa il Wi-Fi: serve se qualcuno l’ha riacceso.',
      },
      camera_dhcp_reservation: {
        title: 'Rifare la prenotazione della camera?',
        body: 'Il router riserva di nuovo l’indirizzo 192.168.1.10 alla camera del kit. La registrazione non si ferma.',
      },
      camera_rtsp_on: {
        title: 'Riaccendere RTSP sulla camera?',
        body: 'Il kit riaccende il flusso video della camera e controlla che risponda. Serve quando la camera smette di mandare segmenti.',
      },
      camera_reboot: {
        title: 'Riavviare la camera?',
        body: 'La camera resta spenta per un paio di minuti. Con una registrazione in corso il kit rifiuta: riprova a partita finita.',
      },
      camera_apply_profile: {
        title: 'Riapplicare l’assetto della camera?',
        body: 'La camera torna a colori, senza scritte sull’immagine e senza audio, con il riavvio settimanale il lunedì alle 4. Con una registrazione in corso il kit rifiuta: riprova a partita finita.',
      },
      read_inventory: {
        title: 'Rileggere router e camera?',
        body: 'Il kit rilegge modello, seriale, firmware e UID di router e camera al prossimo battito, senza aspettare le sei ore.',
      },
    },
    upgradePending:
      'La scatola si aggiornerà entro un quarto d’ora, se non sta registrando e non ha una partita a breve.',
    noAppVersion: 'Mai comunicata',
    retiredOn: 'Ritirato il {date}',
    edit: 'Modifica i dati',
    save: 'Salva le modifiche',
    saving: 'Salvataggio…',
    cancel: 'Annulla',
    saved: 'Modifiche salvate.',
    freeSpace: 'Spazio libero',
    queueDepth: 'Segmenti da caricare',
    clock: 'Orologio',
    signal: 'Segnale',
    signalBars: '{level}/{max}',
    neverReported: 'Mai comunicato',
    clockBehind: 'indietro di {skew}',
    clockAhead: 'avanti di {skew}',
    // A word for the tile's figure, the sentence for the note under it.
    clockStates: {
      synced: { short: 'In orario', long: 'Sincronizzato' },
      rtc_only: { short: 'Interno', long: 'Solo orologio interno' },
      unknown: { short: 'Ignoto', long: 'Sconosciuto' },
      unmeasured: { short: 'Da misurare', long: 'Non ancora misurato' },
    },
    cameras: 'Le telecamere di questa scatola',
    camerasLoading: 'Caricamento telecamere…',
    camerasError: 'Non è stato possibile caricare le telecamere.',
    noCameras: 'Nessuna telecamera su questa scatola.',
    noCamerasDescription: 'Un kit senza telecamera non registra niente.',
    cameraMac: 'Indirizzo MAC',
    cameraSerial: 'Numero di serie',
    cameraModel: 'Modello',
    cameraFirmware: 'Firmware',
    cameraUid: 'UID Reolink',
    cameraUidHelp: 'Il codice sotto il QR dell’etichetta, es. 95270000ABCD1234.',
    cameraQrAlt: 'QR dell’UID della telecamera',
    cameraQrHelp: 'Inquadralo con l’app Reolink per aggiungere la telecamera.',
    noCameraValue: 'Non indicato',
    editCamera: 'Modifica la telecamera',
    cameraSaved: 'Telecamera salvata.',
    cameraUidTaken: 'Un’altra telecamera ha già questo UID.',
    cameraSerialTaken: 'Un’altra telecamera ha già questo numero di serie.',
    cameraMain: 'Alta risoluzione',
    cameraSub: 'Flusso leggero',
    noStream: 'Nessun indirizzo',
    streamStuck: 'Non produce',
    streamLastSegment: 'Ultimo segmento {when}',
    streamNeverProduced: 'Non ha mai prodotto niente',
    streamRelaunches: '{count} rilanci da allora',
  },
  bench: {
    repairOf: 'Cosa diventa',
    repairOfHelp: 'Un kit nuovo, o la scheda di un kit che aspetta un intervento.',
    newKit: 'Un kit nuovo',
    repairBoard: 'Il gateway nuovo del Kit {id}',
    repairSd: 'La SD nuova del Kit {id}',
    title: 'Al banco',
    description:
      'Le scatole accese nell’ultima ora. Scansiona il codice del router e l’ICCID della SIM, poi premi Prepara: la scatola fa il resto.',
    summary: '{toPrepare} da preparare · {preparing} in preparazione',
    list: 'Scatole al banco',
    boxHeading: 'Scatola',
    setupHeading: 'Configurazione',
    progressHeading: 'Avanzamento',
    stateHeading: 'Stato',
    readyToPrepare: 'Pronta da preparare',
    routerMissingRow: 'Router non trovato: controlla il cavo',
    beforePrepare: 'Prima di preparare',
    allStepsDone: 'Tutti i passi fatti',
    stepsProgress: '{done} passi di {total} fatti',
    stepsProgressOne: '{done} passo di {total} fatto',
    facts: 'La scatola {box}',
    toPrepare: 'Da preparare',
    since: 'Al banco da',
    lastSeen: 'Sentita l’ultima volta',
    software: 'Software',
    softwareNone: '—',
    softwareRetrying: 'Riprovo da solo',
    router: 'Router',
    routerFound: 'Trovato',
    routerMissing: 'Non trovato',
    routerMissingHelp: 'Controlla il cavo di rete fra router e gateway.',
    steps: 'Passi',
    stepToDo: 'Da fare',
    waitingForBox: 'La scatola prende il lavoro entro dieci secondi.',
    takenElsewhere:
      'Questa scatola è stata preparata dall’altro ambiente (staging o produzione): seguila da lì.',
    prepare: 'Prepara',
    cancel: 'Annulla',
    routerCode: 'Codice del router',
    routerCodeHelp: 'Il MAC sull’etichetta sotto il router: scansionalo o scrivilo.',
    scanRouterCode: 'Leggi il codice del router',
    simIccid: 'ICCID della SIM',
    simIccidHelp:
      'Le 19 o 20 cifre sotto il codice a barre della tessera della SIM: scansionalo o scrivilo.',
    scanSimIccid: 'Leggi l’ICCID dalla tessera',
    requiredField: 'Campo obbligatorio.',
    retry: 'Riprova',
    openKit: 'Apri il kit',
    loadFailed: 'Non riesco a leggere il banco.',
    refetchFailed:
      'Non riesco ad aggiornare l’elenco: riprovo da solo, i dati qui sotto sono gli ultimi letti.',
    hardwareIdTaken:
      'Questa scheda ha già un kit: aprilo dall’elenco qui sotto. Rifare un kit esistente non si fa ancora dal banco.',
  },
  pitch: {
    title: 'Campi',
    description: 'Le superfici di gioco su cui giocano le società. Area riservata allo staff.',

    // L'elenco
    list: 'Campi censiti',
    searchLabel: 'Cerca per nome o indirizzo',
    createdColumn: 'Aggiunto il',
    noAddress: 'Nessun indirizzo',
    sortLabel: 'Ordina per',
    sortNameAsc: 'Nome (A–Z)',
    sortNameDesc: 'Nome (Z–A)',
    sortCreatedDesc: 'Più recenti prima',
    sortCreatedAsc: 'Meno recenti prima',
    loading: 'Caricamento dei campi…',
    listError: 'Non è stato possibile caricare l’elenco dei campi.',
    empty: 'Nessun campo censito.',
    emptyDescription: 'Aggiungi il primo campo per iniziare.',
    emptySearch: 'Nessun campo corrisponde alla ricerca.',
    emptySearchDescription: 'Controlla la scrittura, o svuota il campo per vederli tutti.',
    clearSearch: 'Svuota la ricerca',
    paginationLabel: 'Paginazione dei campi',
    count: '{total} campi censiti',

    // La scheda, in creazione e in modifica
    newPitch: 'Nuovo campo',
    newPitchDescription:
      'Una riga per superficie di gioco: campo A e campo B dello stesso impianto sono due campi.',
    details: 'Dati del campo',
    name: 'Nome',
    nameHelp: 'Come lo chiamano gli operatori, impianto incluso: Comunale Rivoli - campo A.',
    address: 'Indirizzo',
    addressHelp: 'Dove si trova. È cercabile, così il comune distingue due «Comunale».',
    lndName: 'Nei comunicati della federazione',
    lndNameHelp:
      'Come lo stampa la federazione, per esteso: SORI - COMUNALE. È così che l’importazione dei comunicati riconosce il campo — senza, le partite arrivano senza campo e nessuna telecamera le registra.',
    lndNameEmpty: 'Non collegato',
    lndCode: 'Codice impianto della federazione',
    lndCodeHelp:
      'Le quattro cifre che i programmi delle gare stampano prima del nome: 0084 XXV APRILE. Con il codice, «Controlla ora» riconosce il campo nei comunicati dell’agonistica.',
    lndCodeEmpty: 'Nessun codice',
    requiredField: 'Campo obbligatorio.',
    create: 'Crea campo',
    creating: 'Creazione…',
    edit: 'Modifica',
    save: 'Salva le modifiche',
    saving: 'Salvataggio…',
    cancel: 'Annulla',
    close: 'Chiudi',
    created: 'Campo creato.',
    openCard: 'Apri la scheda',
    saved: 'Modifiche salvate.',
    pitchNotFound: 'Questo campo non esiste, o è stato rimosso.',
    backToList: 'Torna all’elenco',
    // La società: scelta al censimento, elencata nella scheda
    club: 'Società',
    clubHelp: 'Facoltativa. Si può collegare anche dopo, dalla scheda della società.',
    clubPlaceholder: 'Cerca per nome legale o abbreviato',
    clubSearching: 'Ricerca…',
    clubNoMatch: 'Nessuna società corrisponde alla ricerca.',
    clearClub: 'Cambia società',
    isPrimary: 'È il campo principale di questa società',
    clubs: 'Società',
    clubsDescription: 'Chi ci gioca. Un campo comunale ne serve più di una.',
    attachClubLabel: 'Collega una società a questo campo',
    clubsLoading: 'Caricamento delle società…',
    clubsError: 'Non è stato possibile caricare le società di questo campo.',
    noClubs: 'Nessuna società gioca ancora qui.',
    noClubsDescription: 'Collegane una qui sotto, o dalla sezione Campi di una società.',
  },
  season: {
    title: 'Stagioni',
    description:
      'Le stagioni sportive. Derivano dal confine del 1º luglio e compaiono da sé: qui si corregge quando una stagione è andata, se la federazione sposta un confine.',
    list: 'Stagioni',
    current: 'Contiene oggi',
    provisional: 'Date provvisorie',
    startsOn: 'Inizio',
    endsOn: 'Fine',
    correct: 'Correggi',
    save: 'Salva',
    cancel: 'Annulla',
    saved: 'Confine corretto',
  },

  league: {
    title: 'Campionati',
    description:
      'Le categorie in cui è organizzata una stagione, i gironi che la dividono geograficamente, e le squadre iscritte. Area riservata: solo staff.',

    // The list
    loading: 'Caricamento dei gironi…',
    listError: 'Non è stato possibile caricare i gironi.',
    noSeasonDescription:
      "La stagione nell'indirizzo non esiste. Scegline una per vedere e gestire i suoi gironi.",

    newGroup: 'Nuovo girone',
    groupCode: 'Girone {code}',
    codeLabel: 'Codice',
    categoryLabel: 'Categoria',
    requiredField: 'Campo obbligatorio.',
    edit: 'Modifica',
    cancel: 'Annulla',
    created: 'Girone creato.',
    saved: 'Modifiche salvate.',
    deleted: 'Girone eliminato.',
    deleteGroup: 'Elimina il girone',
    groupNotFound: 'Questo girone non esiste, o è stato eliminato.',
    backToList: "Torna all'elenco",

    // L'atlante: le categorie a sinistra, i gironi di quella aperta a destra
    categoriesNav: 'Categorie',
    regionsLabel: 'Regioni',
    regionUnavailable: 'in arrivo',
    regions: {
      'valle-d-aosta': { short: 'VDA', name: 'Valle d’Aosta' },
      piemonte: { short: 'PIE', name: 'Piemonte' },
      lombardia: { short: 'LOM', name: 'Lombardia' },
      'trentino-alto-adige': { short: 'TAA', name: 'Trentino-Alto Adige' },
      veneto: { short: 'VEN', name: 'Veneto' },
      'friuli-venezia-giulia': { short: 'FVG', name: 'Friuli-Venezia Giulia' },
      liguria: { short: 'LIG', name: 'Liguria' },
      'emilia-romagna': { short: 'EMR', name: 'Emilia-Romagna' },
      toscana: { short: 'TOS', name: 'Toscana' },
      umbria: { short: 'UMB', name: 'Umbria' },
      marche: { short: 'MAR', name: 'Marche' },
      lazio: { short: 'LAZ', name: 'Lazio' },
      abruzzo: { short: 'ABR', name: 'Abruzzo' },
      molise: { short: 'MOL', name: 'Molise' },
      campania: { short: 'CAM', name: 'Campania' },
      puglia: { short: 'PUG', name: 'Puglia' },
      basilicata: { short: 'BAS', name: 'Basilicata' },
      calabria: { short: 'CAL', name: 'Calabria' },
      sicilia: { short: 'SIC', name: 'Sicilia' },
      sardegna: { short: 'SAR', name: 'Sardegna' },
    },
    searchCategories: 'Cerca una categoria',
    noMatchingCategory: 'Nessuna categoria corrisponde a questa ricerca.',
    noCategoriesHere: 'Aggiungi la prima da «Gestisci le categorie».',
    delegationFilter: 'Delegazione',
    wholeRegion: 'Tutta la {region}',
    noDelegation: 'Creati qui',
    delegationName: 'Delegazione {delegation}',
    withWithdrawals: 'con un ritiro',
    groupEyebrow: 'Girone',
    teamsOne: '1 squadra',
    teamsMany: '{count} squadre',
    withdrawnOne: '1 ritirata',
    withdrawnMany: '{count} ritirate',
    statGroupsOne: 'girone',
    statGroupsMany: 'gironi',
    statTeamsOne: 'squadra',
    statTeamsMany: 'squadre',
    statWithdrawalsOne: 'retirement',
    statWithdrawalsMany: 'ritiri',
    emptyCategory: 'Ancora nessun girone in questa categoria.',
    newGroupLetter: 'Nuovo girone {code}',
    correctGroup: 'Correggi il girone {code}',
    correctCode: 'Correggi il codice',
    codeInputLabel: 'Codice del girone',
    createLetter: 'Crea girone {code}',
    saveLetter: 'Salva {code}',
    codeTaken: 'Il girone {code} c’è già qui.',

    // The categories a league group is built on
    categoriesTitle: 'Categorie',
    categoriesDescription:
      'La fascia, il limite di età, il livello e il genere su cui si può costruire un girone. Una volta che un girone li usa, i quattro si bloccano.',
    manageCategories: 'Gestisci le categorie',
    manageSeasons: 'Gestisci le stagioni',
    nameLabel: 'Nome',
    ageGroupLabel: 'Fascia',
    underAgeLabel: 'Limite di età',
    tierLabel: 'Livello',
    genderLabel: 'Genere',
    lockedFields: 'Questi campi si bloccano quando un girone usa questa categoria.',
    categoriesLoading: 'Caricamento delle categorie…',
    categoriesListError: 'Non è stato possibile caricare le categorie.',
    noCategories: 'Nessuna categoria censita.',
    noCategoriesDescription: 'Aggiungi la prima qui sotto.',
    newCategory: 'Aggiungi una categoria',
    newCategoryDescription:
      'Scegli i quattro campi su cui si costruisce, poi scrivi il nome come lo stamperà il bollettino.',
    addCategory: 'Aggiungi',
    addingCategory: 'Aggiunta…',
    categoryCreated: 'Categoria aggiunta.',
    saveCategory: 'Salva',
    savingCategory: 'Salvataggio…',
    categorySaved: 'Categoria salvata.',
    deleteCategory: 'Elimina',
    categoryDeleted: 'Categoria eliminata.',

    // The record
    entries: 'Squadre',
    entriesDescription: 'Le squadre iscritte a questo girone.',
    noEntries: 'Nessuna squadra iscritta.',
    noEntriesDescription: 'Aggiungi la prima qui sotto.',
    withdraw: 'Ritira',
    undoWithdraw: 'Annulla ritiro',
    withdrawn: 'Ritirata',
    removeEntry: 'Rimuovi',
    addTeam: 'Aggiungi una squadra',
    teamFieldLabel: 'Società',
    addTeamPlaceholder: 'Cerca per nome società',
    addTeamSearching: 'Ricerca…',
    noCandidates: 'Nessuna squadra corrisponde a questa ricerca.',

    // Le tre sezioni della scheda
    lndDelegationKey: 'Delegazione {delegation} · Girone {code}',
    entriesSection: 'Iscritte',
    calendarSection: 'Calendario',
    standingsSection: 'Classifica',
  },

  // `/matches`: ogni partita di un periodo, fra tutti i gironi, col suo video.
  matchOverview: {
    title: 'Partite',
    description: 'Le partite di un periodo, e se le telecamere le hanno registrate.',
    list: 'Partite del periodo',
    loading: 'Caricamento delle partite…',
    listError: 'Non è stato possibile caricare le partite.',
    empty: 'Nessuna partita in questo periodo.',
    emptyDescription: 'Allarga il periodo o togli un filtro.',
    clearFilters: 'Togli i filtri',
    fromLabel: 'Dal',
    toLabel: 'Al',
    filters: 'Filtri',
    removeFilter: 'Togli il filtro {filter}',
    activeCountOne: '1 filtro attivo',
    activeCountMany: '{count} filtri attivi',
    pitchLabel: 'Campo',
    pitchPlaceholder: 'Cerca un campo',
    pitchSearching: 'Ricerca dei campi…',
    noPitchMatches: 'Nessun campo con questo nome.',
    changePitch: 'Cambia campo',
    clubLabel: 'Società',
    clubPlaceholder: 'Cerca una società',
    clubSearching: 'Ricerca delle società…',
    noClubMatches: 'Nessuna società con questo nome.',
    changeClub: 'Cambia società',
    statusLabel: 'Stato',
    allStatuses: 'Tutti gli stati',
    recordingLabel: 'Registrazione',
    recordingAll: 'Con e senza',
    recordingWith: 'Con registrazione',
    recordingWithout: 'Senza registrazione',
    countOne: '1 partita',
    countMany: '{count} partite',
    paginationLabel: 'Pagine delle partite',
    columnFixture: 'Partita',
    columnVideo: 'Registrazione',
    context: '{category} · {pitch}',
    videoUnplanned: 'Non ancora pianificata',
    videoNone: 'Nessuna registrazione',
    missingOne: '1 segmento mancante',
    missingMany: '{count} segmenti mancanti',
    pitchMatches: 'Partite su questo campo',
    clubMatches: 'Partite di questa società',
  },

  match: {
    loading: 'Caricamento del calendario…',
    listError: 'Il calendario non è stato caricato.',
    empty: 'Nessuna partita in calendario.',
    emptyDescription: 'Aggiungi la prima con «+ Partita».',
    versus: '{home} – {away}',
    whenAndWhere: '{when} · {pitch}',
    withdrewSide: '{club} ritirata',

    railLabel: 'Giornate',
    current: 'in corso',
    onlyToFix: 'Solo da sistemare ({count})',
    previousMatchday: 'Giornata precedente',
    nextMatchday: 'Giornata successiva',
    matchdayTitle: 'Giornata {matchday}',
    backToCurrent: 'torna alla giornata {matchday}',
    addToMatchday: '+ Partita',
    fixturesOne: '1 partita',
    fixturesMany: '{count} partite',
    playedCount: '{count} giocate',
    postponedOne: '1 rinviata da ricollocare',
    postponedMany: '{count} rinviate da ricollocare',
    owingRefereeOne: '1 senza arbitro',
    owingRefereeMany: '{count} senza arbitro',
    withWithdrawnOne: '1 con una squadra ritirata',
    withWithdrawnMany: '{count} con una squadra ritirata',
    markPlayed: 'giocata',
    markPostponed: 'una rinviata',
    markOwingReferee: 'manca un arbitro',
    columnFixture: 'Partita',
    columnReferee: 'Arbitro',
    versusSign: '–',
    versusSpoken: 'contro',
    scoreSpoken: '{home} a {away}',
    refereeAdd: '+ arbitro',
    refereeOf: 'Arbitro di {fixture}',
    refereeSaved: 'Arbitro salvato.',
    close: 'Chiudi',

    edit: 'Modifica',
    remove: 'Elimina',
    removed: 'Partita eliminata.',
    // The page header's own: «Elimina» alone would sit two inches from «Elimina il video».
    removeFixture: 'Elimina la partita',

    newMatch: 'Aggiungi una partita',
    newMatchDescription:
      'Le due squadre vengono dalle iscritte; il campo dalla società di casa, o dalla ricerca accanto.',
    editMatch: 'Modifica la partita',
    homeLabel: 'In casa',
    awayLabel: 'In trasferta',
    sidePlaceholder: 'Scegli una squadra',
    sidesLocked: 'Le squadre non si correggono: elimina la partita e ricreala.',
    noSelectableSides: 'Nessuna squadra iscritta, o tutte le iscritte si sono ritirate.',
    pitchLabel: 'Campo',
    pitchPlaceholder: 'Scegli un campo',
    pitchNeedsHome: 'Scegli prima la squadra di casa.',
    pitchSearchLabel: 'Oppure cerca un altro campo',
    pitchSearchPlaceholder: 'Cerca per nome o indirizzo',
    pitchSearching: 'Ricerca in corso…',
    noPitchMatches: 'Nessun campo corrisponde a questa ricerca.',
    matchdayLabel: 'Giornata',
    legLabel: 'Turno',
    legPlaceholder: 'Scegli',
    kickOffDateLabel: 'Data',
    kickOffTimeLabel: 'Ora',
    kickOffZoneNote: 'Data e ora sono ora italiana, da qualunque posto tu stia leggendo.',
    statusLabel: 'Stato',
    refereeLabel: 'Arbitro',
    refereePlaceholder: 'Facoltativo',
    requiredField: 'Campo obbligatorio.',
    create: 'Aggiungi la partita',
    creating: 'Aggiunta in corso…',
    save: 'Salva le modifiche',
    saving: 'Salvataggio…',
    cancel: 'Annulla',
    created: 'Partita aggiunta.',
    saved: 'Modifiche salvate.',
  },

  recording: {
    pageDescription: 'La partita, e quello che le telecamere del campo hanno mandato su.',
    section: 'Registrazioni',
    loading: 'Caricamento delle registrazioni…',
    listError: 'Non è stato possibile caricare le registrazioni.',
    empty: 'Nessuna registrazione per questa partita.',
    emptyDescription:
      'Su questo campo non era installato nessun gateway quando è stata programmata.',
    matchLoading: 'Caricamento della partita…',
    matchNotFound: 'Partita non trovata.',
    backToLeagues: 'Vai ai gironi',
    window: 'Finestra programmata',
    windowValue: '{start} – {end}',
    segments: '{uploaded} segmenti',
    segmentsMissing: '{uploaded} segmenti · ne mancano almeno {missing}',
    streamDetail: '{size} · ultimo {when}',
    streamNothing: 'Non è arrivato niente',
    playerLabel: 'Registrazione della partita',
    playbackLoading: 'Preparazione del video…',
    playbackError: 'Non è stato possibile preparare il video.',
    playbackStopped: 'Il video si è fermato. I collegamenti ai segmenti scadono dopo qualche ora.',
    playbackEmpty: 'Non c’è ancora niente da riprodurre.',
    playbackMissing: 'Mancano {span}, che il campo deve ancora mandare su.',

    remove: 'Elimina il video',
    removeTitle: 'Eliminare il video di questa registrazione?',
    removeBody:
      'Il video e la registrazione spariscono, dal database e dall’archivio. Non si torna indietro. La copia sul gateway del campo non viene toccata.',
    removeConfirm: 'Elimina definitivamente',
    removed: 'Video eliminato.',
    cancel: 'Annulla',
    closeDialog: 'Chiudi',
  },

  // La convocazione di ciascuna squadra, come serve all'analisi: conta solo quella pubblicata.
  teamSheets: {
    section: 'Convocazioni',
    loading: 'Caricamento della convocazione…',
    loadError: 'Non è stato possibile caricare la convocazione.',
    callUps: '{count} convocati · {numbered} con il numero',
  },

  highlightSettings: {
    section: 'Highlights',
    description:
      'Valgono per tutte le partite: un giocatore senza piano guarda le clip gratis, le altre hanno il lucchetto.',
    loading: 'Caricamento delle impostazioni degli highlights…',
    loadError: 'Non è stato possibile caricare le impostazioni degli highlights.',
    freeClips: 'Clip gratis per partita',
    lifetime: 'Giorni di vita di una clip',
    lifetimeNote:
      'Contati dalla data della partita: il giorno dopo il controllo giornaliero cancella la clip.',
    required: 'Campo obbligatorio.',
    save: 'Salva',
    saved: 'Impostazioni degli highlights salvate, per tutte le partite.',
    shortenTitle: 'Accorciare la vita delle clip?',
    shortenBody:
      'Le clip delle partite più vecchie di {days} giorni verranno cancellate al prossimo controllo giornaliero, per ogni partita, e non tornano più.',
    shortenConfirm: 'Cancella le clip più vecchie',
    cancel: 'Annulla',
    closeDialog: 'Chiudi',
  },

  // L'invio di una partita a UbiTrack. Pseudonimo: il corpo porta i numeri di maglia, mai i nomi.
  analysis: {
    section: 'Analisi',
    loading: "Caricamento dell'analisi…",
    loadError: "Non è stato possibile caricare lo stato dell'analisi.",
    description:
      'A UbiTrack arrivano il video e le due convocazioni con i soli numeri di maglia: nessun nome e nessuna data di nascita.',
    submittedAt: 'Inviata {when}',
    completedAt: 'Completata il {when}',
    failureDetail: 'Motivo indicato: {detail}',
    accepted: 'UbiTrack la sta analizzando.',
    format: 'Formato partita: {players} contro {players}',
    send: 'Invia ad analisi',
    sendAgain: 'Invia di nuovo',
    sent: 'Partita inviata ad analisi.',
    switchTurnOn: "Attiva l'analisi",
    switchTurnOff: "Disattiva l'analisi",
    switchUnavailable: 'Spenta in questo ambiente',
    switchedOn: "L'invio ad analisi è attivo, per tutte le partite.",
    switchedOff: "L'invio ad analisi è spento, per tutte le partite.",
    unchanged: "Nulla è cambiato dall'ultimo invio: UbiTrack ha già questa versione.",
  },

  standings: {
    loading: 'Caricamento della classifica…',
    listError: 'La classifica non è stata caricata.',
    empty: 'La classifica è vuota.',
    emptyDescription: 'Compare quando ci sono squadre iscritte a questo girone.',
    backToEntries: 'Vai alle squadre iscritte',
    notPlayedYet: 'Nessuna partita giocata: è l’ordine di partenza.',
    disclaimer:
      'Ordinata per punti, differenza reti, reti fatte e nome della società. Non è la classifica avulsa FIGC e non indica promozioni o retrocessioni.',
    legend:
      'G giocate · V vinte · N nulle · P perse · GF reti fatte · GS reti subite · DR differenza reti · Pt punti',
    withdrawnExcluded: 'Le squadre ritirate non compaiono.',
    table: 'Classifica',
    positionColumn: 'Pos.',
    clubColumn: 'Squadra',
    playedColumn: 'G',
    wonColumn: 'V',
    drawnColumn: 'N',
    lostColumn: 'P',
    goalsForColumn: 'GF',
    goalsAgainstColumn: 'GS',
    goalDifferenceColumn: 'DR',
    pointsColumn: 'Pt',
  },

  registration: {
    season: 'Stagione',
    seasonsLoading: 'Caricamento stagioni…',
    seasonsError: 'Non è stato possibile caricare le stagioni.',
    unknownSeason: 'Stagione non trovata',
    unknownSeasonDescription:
      "L'annata nell'indirizzo non esiste. Scegline una per vederne e gestirne i giocatori.",
    registeredOn: 'Tesserato dal',
    registeredOnHelp: 'La data sul modulo. Può essere retrodatata.',
    active: 'In rosa',
    stateFilter: 'Stato',
    stateAll: 'Tutti',
    stateReleased: 'Svincolati',
    releasedOn: 'Svincolato il {date}',
    release: 'Svincola',
    released: 'Giocatore svincolato.',
    restore: 'Annulla svincolo',
    restored: 'Svincolo annullato.',
  },
  // Le etichette dell'anagrafica che non appartengono né al registro né alla scheda da
  // sole: le rendono sia il modulo di tesseramento sia la scheda di una persona.
  identity: {
    lastName: 'Cognome',
    firstName: 'Nome',
    birthDate: 'Data di nascita',
    birthDateHelp: 'Insieme a nome e cognome identifica la persona.',
    position: 'Ruolo',
    positionPlaceholder: 'Non indicato',
    sex: 'Sesso',
    sexPlaceholder: 'Non indicato',
    foot: 'Piede',
    footPlaceholder: 'Non dichiarato',
    nationality: 'Nazionalità',
    nationalityPlaceholder: 'Non dichiarata',
    nationalitySearch: 'Cerca una nazione',
    nationalityEmpty: 'Nessuna nazione con questo nome',
    taxCode: 'Codice fiscale',
    taxCodeHelp: 'Facoltativo. Sedici caratteri, come sulla tessera sanitaria.',
    taxCodeRequiredHelp: 'Sedici caratteri, come sulla tessera sanitaria.',
    figcNumber: 'Matricola',
    figcNumberHelp:
      'Facoltativa. Quella del cartellino FIGC: resta la stessa se il giocatore cambia società.',
    taxCodeMissing: 'Non indicato',
    phone: 'Telefono',
    phoneHelp: 'Vuoto per un minore: il contatto è del tutore.',
    email: 'Email',
  },
  player: {
    title: 'Giocatori',
    description: 'I giocatori tesserati con questa società, stagione per stagione.',
    loading: 'Caricamento giocatori…',
    listError: 'Non è stato possibile caricare i giocatori.',
    empty: 'Nessun giocatore tesserato',
    emptyDescription: 'Tessera il primo per questa stagione.',
    emptySearch: 'Nessun giocatore corrisponde alla ricerca',
    emptySearchDescription: 'Prova con un altro cognome, o azzera la ricerca.',
    clearSearch: 'Azzera la ricerca',
    searchLabel: 'Cerca per cognome',
    list: 'Giocatori tesserati con la società',
    count: '{total} giocatori',
    paginationLabel: 'Pagine dei giocatori',

    register: 'Tessera un giocatore',
    registerDescription: 'Cerca prima in anagrafica: la stessa persona non va inserita due volte.',
    findLabel: 'Già in anagrafica?',
    findPlaceholder: 'Cerca per cognome',
    findSearching: 'Ricerca in corso…',
    findNoMatch: 'Nessuno trovato. Compila i campi per aggiungerlo.',
    change: 'Cambia giocatore',
    onFile: "Preso dall'anagrafica. I suoi dati si modificano dalla sua scheda.",
    openCard: 'Apri la scheda',
    submit: 'Tessera per {season}',
    submitting: 'Tesseramento in corso…',
    registered: '{name} tesserato.',

    registerTitle: 'Giocatori',
    registerDescriptionPage: 'Tutti quelli che giocano, per ogni societ\u00e0 e stagione.',
    registerList: 'Anagrafica dei giocatori',
    registerHint: 'I giocatori si tesserano dalla scheda di una societ\u00e0.',
    ageYears: '{age} anni',
    notRegistered: 'Non tesserato',
    requiredField: 'Campo obbligatorio.',
    sortLabel: 'Ordina per',
    sortLastNameAsc: 'Cognome (A\u2013Z)',
    sortLastNameDesc: 'Cognome (Z\u2013A)',
    sortBirthDateDesc: 'Dai pi\u00f9 giovani',
    sortBirthDateAsc: 'Dai pi\u00f9 grandi',
  },
  // La scheda su `/people/$id`. Le etichette dell'anagrafica vivono in `identity`; qui
  // resta il resto del testo della scheda.
  person: {
    loading: 'Caricamento della scheda…',
    listError: 'Non è stato possibile caricare la scheda.',
    details: 'Anagrafica',
    requiredField: 'Campo obbligatorio.',
    edit: 'Modifica',
    save: 'Salva',
    saving: 'Salvataggio…',
    cancel: 'Annulla',
    saved: 'Anagrafica aggiornata.',
    positionSaveFailedAfterAnagrafica:
      'L’anagrafica è stata salvata, ma la posizione no: riprova dalla scheda.',
    personNotFound: 'Questa anagrafica non esiste',
    backToRegister: 'Torna all’anagrafica',
    registrations: 'Tesseramenti',
    registrationsDescription: 'Ogni stagione in cui è stato tesserato, dalla più recente.',
    noRegistrations: 'Mai tesserato',
    editAppointment: 'Modifica l’incarico al {club}',
    appointmentSaved: 'Incarico aggiornato.',
    appointments: 'Incarichi',
    appointmentsDescription: 'Ogni incarico di questa persona, dalla stagione più recente.',
    appointmentsTable: 'Gli incarichi di questa persona',
    noAppointments: 'Nessun incarico',
    accountTitle: 'Account',
    noAccount: 'Questa persona non ha un account di accesso.',
  },
  // The organigramma: everyone at a club who does not play.
  official: {
    title: 'Organigramma',
    description: 'Chi manda avanti la società, stagione per stagione.',
    loading: 'Caricamento dell’organigramma…',
    listError: 'Non è stato possibile caricare l’organigramma.',
    empty: 'Nessun incarico assegnato',
    emptyDescription: 'Assegna il primo per questa stagione.',
    clubBand: 'Società',
    noTeamBand: 'Nessuna squadra',
    noSeasonDescription:
      "L'annata nell'indirizzo non esiste. Scegline una per vederne e gestirne gli incarichi.",
    inCharge: 'In carica',
    endedOn: 'Concluso il {date}',
    endedWithSeason: 'Conclusa la stagione',
    accountLinkedTitle: 'Questa persona ha già un account Volée',
    accountLinked: 'Riceverà un invito da accettare: l’incarico parte quando lo accetta.',
    accountUnlinkedTitle: 'C’è già un account Volée su {email}',
    accountUnlinked:
      'Non è collegato a nessuna anagrafica, quindi il solo incarico non dà accesso. Invitala: accettando, quell’account si collega a questa persona.',
    stateFilter: 'Stato',
    stateAll: 'Tutti',
    stateEnded: 'Conclusi',
    unknownTeam: 'Squadra {id}',

    findLabel: 'Già in anagrafica?',
    findPlaceholder: 'Cerca per cognome',
    findSearching: 'Ricerca…',
    findNoMatch: 'Nessuno trovato. Compila i campi per inserirlo.',
    onFile: 'Presa dall’anagrafica. I suoi dati si modificano dalla sua scheda.',
    change: 'Cambia persona',
    appoint: 'Assegna un incarico',
    appointDescription:
      'Una persona già in anagrafica viene riusata: stesso nome e stessa data di nascita sono la stessa persona.',
    lastName: 'Cognome',
    firstName: 'Nome',
    birthDate: 'Data di nascita',
    birthDateHelp: 'Insieme ai due nomi identifica la persona.',
    role: 'Ruolo',
    rolePlaceholder: 'Scegli un ruolo',
    team: 'Squadra',
    teamPlaceholder: 'Scegli una squadra',
    teamClubWide: 'Questo ruolo è di società.',
    teamsLoading: 'Caricamento delle squadre…',
    noTeams: 'La società non ha ancora squadre: aggiungine una prima.',
    email: 'Email',
    emailHelp: 'Dove arriva l’invito, se lo mandi.',
    phone: 'Telefono',
    invite: 'Invitalo nell’app',
    inviteHelp: 'Non serve un account a tutti: il medico sociale è una riga, non un accesso.',
    submit: 'Assegna per {season}',
    submitting: 'Assegnazione…',
    submitInvite: 'Invita per {season}',
    submittingInvite: 'Invio…',
    appointed: 'Incarico assegnato a {name}.',
    requiredField: 'Campo obbligatorio.',

    endedOnField: 'Concluso il',
    endedOnFieldHelp: 'Vuoto significa in carica. Si può retrodatare.',
    addressLabel: 'Manda l’invito a',
    send: 'Manda',
    cancelInvite: 'Annulla',
    end: 'Concludi',
    ended: 'Incarico concluso.',
    reopen: 'Annulla',
    reopened: 'Incarico riaperto.',
    sendInvitation: 'Invita',
    invitationNeedsTeam: 'Si invita solo su un posto: dai prima una squadra a questa persona.',
    teamInviteNote: 'Si invita solo su un posto: scegli la squadra.',
    resend: 'Rimanda',
    invitationMailed: 'Invito inviato a {email}.',
    revoke: 'Revoca',
    invitationRevoked: 'Invito revocato.',
    notEmailed: 'Invito creato, ma la mail non è partita: rimandalo dalla lista.',
    pendingTitle: 'Inviti in attesa',
    pendingError: 'Non è stato possibile caricare gli inviti in attesa.',
    pendingState: 'In attesa',
    expiredState: 'Scaduto',
    offerExpires: 'scade il {date}',
    offerExpired: 'scaduto il {date}',
    resent: 'Invito rimandato a {email}.',
    revokeTitle: 'Revocare l’invito a {email}?',
    revokeBody: 'Il link smetterà di funzionare.',
    revokeCancel: 'Annulla',
  },
  // Every incarico across every club: the direction the organigramma cannot read.
  register: {
    title: 'Incarichi',
    description: 'Chi ha un incarico, attraverso tutte le società.',
    sections: 'Sezioni degli incarichi',
    tabRegister: 'Anagrafica',
    tabRequests: 'Richieste',
    list: 'L’anagrafica degli incarichi',
    searchLabel: 'Cerca per cognome o nome',
    roleFilter: 'Filtra per ruolo',
    allRoles: 'Tutti i ruoli',
    stateFormer: 'Usciti',
    stateFormerHint: 'Conclusi, e senza nessun altro incarico aperto.',
    loading: 'Caricamento dell’anagrafica…',
    listError: 'Non è stato possibile caricare l’anagrafica degli incarichi.',
    empty: 'Nessuno ha ancora un incarico.',
    emptyDescription: 'Gli incarichi si assegnano dalla scheda di una società.',
    emptySearch: 'Nessuno corrisponde a questi filtri.',
    emptySearchDescription: 'Controlla la scrittura, o svuota i filtri per vederli tutti.',
    clearFilters: 'Svuota i filtri',
    count: '{total} persone',
    paginationLabel: 'Paginazione dell’anagrafica degli incarichi',
    sortLabel: 'Ordina per',
    sortLastNameAsc: 'Cognome (A–Z)',
    sortLastNameDesc: 'Cognome (Z–A)',
  },
  registrationRequest: {
    title: 'Richieste di registrazione',
    description:
      'Le società che hanno chiesto di entrare in Volée. Leggi il documento, poi approva, chiedi un’integrazione o respingi.',
    loading: 'Caricamento delle richieste…',
    listError: 'Non è stato possibile caricare le richieste.',
    empty: 'Niente da esaminare',
    emptyDescription: 'Nessuna società ha ancora chiesto di entrare.',
    emptyFiltered: 'Nessuna richiesta in questo stato',
    emptyFilteredDescription: 'Togli il filtro per vedere tutte le richieste.',
    clearFilter: 'Togli il filtro',
    statusFilter: 'Stato',
    allStatuses: 'Tutti',
    list: 'Richieste di registrazione',
    paginationLabel: 'Paginazione delle richieste',
    count: '{total} richieste',

    detailTitle: 'Richiesta di registrazione',
    detailDescription: 'Quello che il richiedente ha mandato, e la decisione che spetta a te.',
    backToQueue: 'Torna alle richieste',
    requestLoading: 'Caricamento della richiesta…',
    notFound: 'Questa richiesta non esiste',
    applicant: 'Richiedente',
    email: 'Email',
    phone: 'Telefono',
    club: 'Società',
    status: 'Stato',
    submittedAt: 'Inviata',
    reviewedAt: 'Decisa',
    document: 'Documento',
    openDocument: 'Apri il documento',
    noDocument: 'Non è stato allegato nessun documento.',
    notSubmitted: 'Non registrata',

    decide: 'La decisione',
    reviewerNote: 'il motivo (lo legge chi ha fatto richiesta)',
    reviewerNoteHelp: 'Viaggia nella mail e compare sulla schermata di stato del richiedente.',
    reasonRequired: 'Scrivi il motivo: lo legge chi ha fatto richiesta.',
    approve: 'Approva',
    requestIntegration: 'Chiedi un’integrazione',
    reject: 'Respingi',
    deciding: 'Invio…',
    approved: 'Richiesta approvata.',
    integrationRequested: 'Al richiedente è stata chiesta un’integrazione.',
    rejected: 'Richiesta respinta.',
    decided: 'Questa richiesta è già stata decisa.',
    reviewerNoteSent: 'Che cosa è stato detto al richiedente',
  },
  staff: {
    title: 'Staff',
    description: 'Chi può entrare nel backoffice, e fino a quando.',

    list: 'Staff Volée',
    searchLabel: 'Cerca per email, cognome o nome',
    roleFilter: 'Filtra per ruolo',
    allRoles: 'Tutti i ruoli',
    stateFilter: 'Filtra per stato',
    allStates: 'In servizio e revocati',
    sortLabel: 'Ordina per',
    sortEmailAsc: 'Email (A–Z)',
    sortEmailDesc: 'Email (Z–A)',
    sortSinceDesc: 'Dai più recenti',
    sortSinceAsc: 'Dai più anziani in servizio',
    noName: 'Nome non ancora nel profilo',
    sinceLine: 'in servizio dal {date}',
    untilLine: 'fino al {date}',
    inService: 'In servizio',
    revoked: 'Revocato',
    loading: 'Caricamento dello staff…',
    listError: 'Non è stato possibile caricare l’elenco dello staff.',
    empty: 'Nessuno ha ancora accesso.',
    emptyDescription: 'Non è ancora stata invitata nessuna persona.',
    emptySearch: 'Nessuno corrisponde ai filtri.',
    emptySearchDescription: 'Controlla la scrittura, o svuota i filtri per vedere tutti.',
    clearFilters: 'Svuota i filtri',
    paginationLabel: 'Paginazione dello staff',
    count: '{total} persone nello staff',
    grantOnlyNote:
      'La revoca dell’accesso resta un’operazione sul database, e ogni modifica è tracciata.',

    invite: 'Invita una persona',
    inviteDescription:
      'Indica l’email e il ruolo. La persona riceve per email una password temporanea e ne sceglie una propria al primo accesso.',
    inviteDetails: 'Dati dell’invito',
    email: 'Email',
    emailHelp: 'L’indirizzo di lavoro Volée. È anche il nome utente per l’accesso.',
    role: 'Ruolo',
    roleHelp: 'Amministratore concede anche il diritto di invitare altre persone.',
    rolePlaceholder: 'Scegli un ruolo',
    requiredField: 'Campo obbligatorio.',
    inviteSubmit: 'Invia l’invito',
    inviting: 'Invio…',
    cancel: 'Annulla',
    closeDialog: 'Chiudi',
    invited: 'Invito inviato.',

    resetSecondFactor: 'Azzera la verifica in due passaggi',
    resetSecondFactorTitle: 'Azzerare la verifica in due passaggi?',
    resetSecondFactorBody:
      'Entrerà con la sola password finché non la riattiva, e riceve un’email che dice che è successo.',
    resetSecondFactorConfirm: 'Azzera',
    resetDone: 'Verifica in due passaggi azzerata.',
    resetWasOff: 'Su quell’account la verifica in due passaggi non era attiva.',
    resetEmailFailed: 'Non è stato possibile avvisare la persona via email: diglielo tu.',
  },
  users: {
    title: 'Utenti',
    description: 'Chi ha un account, chi ha un piano e chi ha comprato qualcosa.',

    list: 'Account',
    searchLabel: 'Cerca per email, cognome o nome',
    typeFilter: 'Tipo di account',
    customers: 'Clienti',
    staffAccounts: 'Staff',
    allTypes: 'Tutti',
    planFilter: 'Piano',
    allPlans: 'Tutti',
    purchasesFilter: 'Acquisti',
    allPurchases: 'Tutti',
    withPurchases: 'Con acquisti',
    withoutPurchases: 'Senza',
    sortLabel: 'Ordina per',
    sortNewest: 'Registrazione più recente',
    sortOldest: 'Registrazione più vecchia',
    sortLastSeen: 'Ultimo accesso',

    free: 'Free',
    covered: 'Con piano',
    paymentOverdue: 'Pagamento in ritardo',
    staff: 'Staff',
    deactivated: 'Disattivato',
    purchaseOne: '1 acquisto',
    purchaseMany: '{count} acquisti',
    registeredLine: 'Registrato il {date}',
    lastSeenLine: 'Ultimo accesso {date}',
    never: '—',

    loading: 'Caricamento degli account…',
    listError: 'Non è stato possibile caricare gli account.',
    empty: 'Ancora nessun account.',
    emptyDescription: 'Gli account compaiono qui appena qualcuno si registra.',
    emptySearch: 'Nessun account corrisponde a questi filtri.',
    emptySearchDescription: 'Controlla l’ortografia, o togli i filtri per vedere tutti i clienti.',
    clearFilters: 'Togli i filtri',
    paginationLabel: 'Paginazione degli account',
    count: '{total} account',

    recordLoading: 'Caricamento dell’account…',
    recordError: 'Non è stato possibile caricare l’account.',
    notFound: 'Questo account non esiste.',
    backToList: 'Torna agli utenti',
    openInStripe: 'Apri su Stripe',

    accountTitle: 'Account',
    email: 'Email',
    type: 'Tipo',
    customer: 'Cliente',
    registered: 'Registrato',
    lastSeen: 'Ultimo accesso',
    deactivatedOn: 'Disattivato il',
    openPerson: 'Apri la scheda della persona',

    paysTitle: 'Piani che paga',
    coveredByTitle: 'Piani che lo coprono',
    noPlan: 'Nessun piano',
    paidBy: 'Pagato da {email}',
    renewsOn: 'Si rinnova il {date}',
    periodEndsOn: 'Periodo fino al {date}',
    planCancelling: 'Disdetto, scade il {date}',

    purchasesTitle: 'Acquisti',
    noPurchases: 'Nessun acquisto',
    purchasedOn: 'Acquistato il {date}',
    revokedOn: 'Revocato il {date}',
  },
  forbidden: {
    title: 'Accesso negato',
    signedInAs: 'Hai effettuato l’accesso come {email}.',
    reason: {
      'no-role': 'Il tuo profilo non ha i permessi per questa sezione del backoffice.',
      'admin-required': 'Questa operazione è riservata agli amministratori Volée.',
      'not-linked':
        'L’accesso è andato a buon fine, ma questo account non è ancora collegato a un profilo Volée. Chiedi a un amministratore di collegarlo, oppure entra con un altro account.',
      deactivated: 'Questo account è stato disattivato e non può più essere usato.',
      refused: 'Questo account non può usare il backoffice.',
    },
  },
  notFound: {
    title: 'Pagina non trovata',
    description: 'L’indirizzo che hai aperto non esiste.',
    backToHome: 'Torna alla home',
  },
  loading: {
    pending: 'Caricamento…',
  },
  error: {
    title: 'Qualcosa non ha funzionato',
    retry: 'Riprova',
    backToHome: 'Torna alla home',
  },
}
